import Vue from 'vue'

// This should be used for listening to custom menu callbacks
export const menuBus = new Vue()

export default menuBus
